import { Box, MantineSize, Stack, Text } from '@mantine/core';
import { isArray } from 'lodash';
import React from 'react';
import { ControlledInputs } from '../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { formatIdentifier } from '../../../../../../react-commons/utils/utilFunctions';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { useSystemInformationActions } from '../../../../resource/services/systemInformationService';

export const Controlled_PropertySystemSettingsSwitchInput= ({
    propertyValidationInformation: { propertyIdentifier, resourceType },
    checked,
    size,
    disabled,
    onChange,
    readOnly,
    hideLabel = false,
}: {
    propertyValidationInformation: PropertyValidationInformation;
    size?: MantineSize;
    checked: boolean;
    disabled?: boolean;
    onChange?: (newValue: boolean) => void;
    readOnly?: boolean;
    hideLabel?: boolean;
}) => {
    const propertyDetails = useSystemInformationActions().useGetPropertyDetails(
        propertyIdentifier,
        resourceType
    );

    const label =
        hideLabel ? undefined
        : isArray(propertyDetails) ?
            propertyDetails[0]?.displayName ?
                propertyDetails[0]?.displayName
            :   formatIdentifier(propertyDetails[0]?.propertyName ?? '')
        : propertyDetails?.displayName ? propertyDetails.displayName
        : formatIdentifier(propertyDetails?.propertyName ?? '');

    const isReadOnly =
        readOnly !== undefined ? readOnly
        : isArray(propertyDetails) && propertyDetails[0]?.updatable !== undefined ? !propertyDetails[0].updatable
        : !isArray(propertyDetails) && propertyDetails?.updatable !== undefined ? !propertyDetails.updatable
        : false;

    const description =
        isArray(propertyDetails) ?
            propertyDetails[0]?.description ?
                propertyDetails[0]?.description
            :   formatIdentifier('')
        : propertyDetails?.description ? propertyDetails.description
        : formatIdentifier('');

    return (
        <>
            <Box style={{ paddingLeft: '4px', paddingRight: '4px', marginTop: 'auto', marginBottom: 'auto' }}>
                <ControlledInputs.BooleanSwitch
                    value={checked}
                    size={size}
                    readOnly={isReadOnly}
                    onChange={(newValue) => onChange?.(newValue)}
                    disabled={disabled}
                />
            </Box>
            <Stack gap={1} style={{ paddingLeft: '4px', paddingRight: '4px' }}>
                <Text fw={'700'} children={label} />
                <Text children={description} />
            </Stack>
        </>
    );
};
